import KoreanLunarCalendar from 'korean-lunar-calendar';

const STEMS = ['갑','을','병','정','무','기','경','신','임','계'];
const BRANCHES = ['자','축','인','묘','진','사','오','미','신','유','술','해'];
const BRANCH_ANIMALS = ['쥐','소','호랑이','토끼','용','뱀','말','양','원숭이','닭','개','돼지'];

// 음력 → 양력 변환
export function lunarToSolar(year, month, day, isLeapMonth = false) {
  try {
    const cal = new KoreanLunarCalendar();
    cal.setLunarDate(year, month, day, isLeapMonth);
    const s = cal.getSolarCalendar();
    if (!s || !s.year) return null;
    return { year: s.year, month: s.month, day: s.day };
  } catch {
    return null;
  }
}

// 년도 → 천간지지
function getYearPillar(year) {
  const stemIdx = (year - 4) % 10;
  const branchIdx = (year - 4) % 12;
  return `${STEMS[(stemIdx + 10) % 10]}${BRANCHES[(branchIdx + 12) % 12]}년`;
}

// 월 → 지지 (절기 기준 근사값)
function getMonthPillar(month) {
  const branchIdx = (month + 1) % 12;
  return `${BRANCHES[branchIdx]}월`;
}

// 일 → 간지 (근사값 — Phase 0 수준)
function getDayPillar(year, month, day) {
  const base = new Date(1900, 0, 1);
  const target = new Date(year, month - 1, day);
  const diff = Math.floor((target - base) / 86400000);
  const stemIdx = diff % 10;
  const branchIdx = diff % 12;
  return `${STEMS[(stemIdx + 10) % 10]}${BRANCHES[(branchIdx + 12) % 12]}일`;
}

// 시 → 지지 (2시간 단위)
function getHourPillar(hour) {
  const branchIdx = Math.floor(((hour + 1) % 24) / 2) % 12;
  return `${BRANCHES[branchIdx]}시`;
}

// solar year/month/day 기준으로 사주 문자열 반환
export function getSajuText(year, month, day, hour) {
  if (!year || !month || !day) return '';
  const yearPillar = getYearPillar(year);
  const monthPillar = getMonthPillar(month);
  const dayPillar = getDayPillar(year, month, day);
  const hourPillar = hour !== null && hour !== undefined ? getHourPillar(hour) : null;
  return [yearPillar, monthPillar, dayPillar, hourPillar].filter(Boolean).join(' ');
}

export function getBirthAnimal(year) {
  return BRANCH_ANIMALS[(year - 4 + 12) % 12];
}

const STEMS_HAN = ['甲','乙','丙','丁','戊','己','庚','辛','壬','癸'];

export function getSajuStructured(year, month, day, hour) {
  if (!year || !month || !day) return null;
  const yearPillar = getYearPillar(year);
  const monthPillar = getMonthPillar(month);
  const dayPillar = getDayPillar(year, month, day);
  const hourPillar = hour != null && hour !== '' ? getHourPillar(Number(hour)) : null;

  const base = new Date(1900, 0, 1);
  const target = new Date(year, month - 1, day);
  const diff = Math.floor((target - base) / 86400000);
  const ilgan = STEMS_HAN[((diff % 10) + 10) % 10];

  return {
    year: yearPillar,
    month: monthPillar,
    day: dayPillar,
    hour: hourPillar,
    ilgan,
    text: [yearPillar, monthPillar, dayPillar, hourPillar].filter(Boolean).join(' '),
  };
}
